export const FETCH_DIAGNOSES_REQUEST = 'FETCH_DIAGNOSES_REQUEST';
export const FETCH_DIAGNOSES_SUCCESS = 'FETCH_DIAGNOSES_SUCCESS';
export const FETCH_DIAGNOSES_FAILURE = 'FETCH_DIAGNOSES_FAILURE';

export const CREATE_DIAGNOSIS_REQUEST = 'CREATE_DIAGNOSIS_REQUEST';
export const CREATE_DIAGNOSIS_SUCCESS = 'CREATE_DIAGNOSIS_SUCCESS';
export const CREATE_DIAGNOSIS_FAILURE = 'CREATE_DIAGNOSIS_FAILURE';

export const UPDATE_DIAGNOSIS_REQUEST = 'UPDATE_DIAGNOSIS_REQUEST';
export const UPDATE_DIAGNOSIS_SUCCESS = 'UPDATE_DIAGNOSIS_SUCCESS';
export const UPDATE_DIAGNOSIS_FAILURE = 'UPDATE_DIAGNOSIS_FAILURE';

export const DELETE_DIAGNOSIS_REQUEST = 'DELETE_DIAGNOSIS_REQUEST';
export const DELETE_DIAGNOSIS_SUCCESS = 'DELETE_DIAGNOSIS_SUCCESS';
export const DELETE_DIAGNOSIS_FAILURE = 'DELETE_DIAGNOSIS_FAILURE';

export const fetchDiagnosesRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_DIAGNOSES_REQUEST,
        payload: { projectId,page, limit, search },
        
      }; 
    };
export const fetchDiagnosesSuccess = (diagnoses) => ({ type: FETCH_DIAGNOSES_SUCCESS, payload: diagnoses });
export const fetchDiagnosesFailure = (error) => ({ type: FETCH_DIAGNOSES_FAILURE, payload: error });

export const createDiagnosisRequest = (data, projectId) => ({ type: CREATE_DIAGNOSIS_REQUEST, payload: { data, projectId } });
export const createDiagnosisSuccess = (diagnosis) => ({ type: CREATE_DIAGNOSIS_SUCCESS, payload: diagnosis });
export const createDiagnosisFailure = (error) => ({ type: CREATE_DIAGNOSIS_FAILURE, payload: error });

export const updateDiagnosisRequest = (id, data,projectId) => ({ type: UPDATE_DIAGNOSIS_REQUEST, payload: { id, data,projectId } });
export const updateDiagnosisSuccess = (diagnosis) => ({ type: UPDATE_DIAGNOSIS_SUCCESS, payload: diagnosis });
export const updateDiagnosisFailure = (error) => ({ type: UPDATE_DIAGNOSIS_FAILURE, payload: error });

export const deleteDiagnosisRequest = (projectId,id) => ({ type: DELETE_DIAGNOSIS_REQUEST, payload: {id,projectId} });
export const deleteDiagnosisSuccess = (id) => ({ type: DELETE_DIAGNOSIS_SUCCESS, payload: id });
export const deleteDiagnosisFailure = (error) => ({ type: DELETE_DIAGNOSIS_FAILURE, payload: error });
